import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPAiOperator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 9,
				cy: 6.5,
				r: 3,
				stroke: "#005AFF",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.2 6.5a4.8 4.8 0 0 1 9.6 0",
				stroke: "#32C8DC",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 8.7c.8.5 1.2 1 1.2 1.8",
				stroke: "#005AFF",
				strokeWidth: 1.3
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 14.2c2.2-2 7.8-2 10 0",
				stroke: "#005AFF",
				strokeWidth: 1.5
			})
		]
	})
});
export default SvgPAiOperator;
